// packages/is-shallow-equal/src/index.ts
import isShallowEqualObjects from "./objects";
import isShallowEqualArrays from "./arrays";
import { default as default2 } from "./objects";
import { default as default3 } from "./arrays";
function isShallowEqual(a, b) {
  if (a && b) {
    if (a.constructor === Object && b.constructor === Object) {
      return isShallowEqualObjects(a, b);
    } else if (Array.isArray(a) && Array.isArray(b)) {
      return isShallowEqualArrays(a, b);
    }
  }
  return a === b;
}
export {
  isShallowEqual as default,
  default3 as isShallowEqualArrays,
  default2 as isShallowEqualObjects
};
//# sourceMappingURL=index.js.map
